import { IStore } from 'Store/.';
import { createSelector } from 'reselect';

const getIsFetching = (state: IStore) => state.infoGroupBooking.isFetching;
const getIsFetchFailed = (state: IStore) => state.infoGroupBooking.isFetchFailed;
const getGroupContent = (state: IStore) => state.infoGroupBooking.content;

export {
  getIsFetching,
  getIsFetchFailed,
  getGroupContent,
};


// WEBPACK FOOTER //
// ./src/pages/InfoGroupBookingPage/Redux/selectors.tsx